import 'babel-polyfill'
import Vue from 'vue'
import App from 'components/app.vue'
import Icon from 'vue-awesome/components/Icon.vue'

Vue.component('icon', Icon)

const client = new Vue({
  render: h => h(App)
})

// When DOM is loaded, mount Vue instance
document.addEventListener('DOMContentLoaded', function () {
  client.$mount('#client')
})



// WEBPACK FOOTER //
// ./client/index.es6